module.exports = __webpack_public_path__ + "img/ResetPanelDMPEnActivacion.e5ba333d.svg";